/* globals process */
import { store } from "../_helpers";
import { modalAlert } from "../_actions";

export const api = {
  getFetch,
  postFetch,
  putFetch,
  deleteFetch,
  queryParams,
  postFormData
};

function getFetch(link, params, token, errorMsg) {
  let url = "";
  let buildParams = "";
  if (typeof params !== "undefined") {
    buildParams = queryParams(params);
    url = process.env.REACT_APP_API_HOST + link + "?" + buildParams;
  } else {
    url = process.env.REACT_APP_API_HOST + link;
  }

  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      //if fetch error, error modal pop up.
      response.errorMsg = errorMsg ? errorMsg : null;
      store.dispatch(modalAlert(response));
      // stop promise if error
      return new Promise(function() {});
    }
  });
}

function postFormData(link, formData, token, errorMsg) {
  return fetch(process.env.REACT_APP_API_HOST + link, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token
    },
    body: formData
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      //if fetch error, error modal pop up.
      response.errorMsg = errorMsg ? errorMsg : null;
      store.dispatch(modalAlert(response));
      // stop promise if error
      return new Promise(function() {});
    }
  });
}

function postFetch(link, params, token, errorMsg, propagateError) {
  return fetch(process.env.REACT_APP_API_HOST + link, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(params)
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      //if fetch error, error modal pop up.
      response.json().then(json => {
        response.errorMsg = errorMsg ? errorMsg : null;
        response.errorDetails = json;
        store.dispatch(modalAlert(response));
      });
      // stop promise if error
      if (!propagateError) {
        return new Promise(function() {});
      }
    }
  });
}

function putFetch(link, params, token, errorMsg) {
  return fetch(process.env.REACT_APP_API_HOST + link, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(params)
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      //if fetch error, error modal pop up.
      response.errorMsg = errorMsg ? errorMsg : null;
      store.dispatch(modalAlert(response));
      // stop promise if error
      return new Promise(function() {});
    }
  });
}

function deleteFetch(link, params, token, errorMsg) {
  return fetch(process.env.REACT_APP_API_HOST + link, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(params)
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      //if fetch error, error modal pop up.
      response.errorMsg = errorMsg ? errorMsg : null;
      store.dispatch(modalAlert(response));
      // stop promise if error
      return new Promise(function() {});
    }
  });
}

function queryParams(params) {
  return Object.keys(params)
    .map(k => {
      if (Array.isArray(params[k])) {
        return params[k].map(val => encodeURIComponent(k) + "=" + encodeURIComponent(val)).join("&");
      }
      return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
    })
    .join("&");
}



// WEBPACK FOOTER //
// ./src/_services/api.js